import { Button, Divider, Form, Input, message } from "antd";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import api from "../../services/api";
import { Container, ContainerCode, ContainerEmail, Title } from "./style";

export function TokenEmail({ contact, cpf }) {

  const key = 'updatable';
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [loadingResend, setLoadingResend] = useState(false);
  const navigate = useNavigate();

  function resend() {
    form
    .validateFields()
    .then(async (values) => {
      setLoadingResend(true);
      api.post('/users/token/email', { cpf: cpf.replace(/\.|-/gm,'')} )
      .then(response => {
        message.success({ content: 'Reenviamos o token para o seu e-mail!', key, duration: 2 });
        setLoadingResend(false);
      }).catch(error => {
        message.error({ content: 'Código inválido', key, duration: 2 });
        setLoadingResend(false);
      })
    })
  }

  function onFinish(value) {
    form
    .validateFields()
    .then(async (values) => {
      setLoading(true);
      api.put('/users/token/email', { token: value.code, cpf: cpf.replace(/\.|-/gm,'') })
      .then(response => {
        setLoading(false);
        localStorage.setItem('oldUser', JSON.stringify(response.data))
        navigate('/register-user');
      }).catch(error => {
        message.error({ content: 'Código inválido', key, duration: 2 });
        setLoading(false);
      })
    })
  }

  return(
    <>
      <Container>
        <Title>
          Cadastro
        </Title>
        <div className="span-register">
          <span>
            Um token foi enviado para o seu e-mail para validação do cadastro
          </span>
        </div>
        <Divider />
        <ContainerEmail>
          <h2>{contact}</h2>
        </ContainerEmail>
        <div className="type-code">
          <p>Digite o código de 6 dígitos que enviamos para você.</p>
        </div>
        <ContainerCode>
          <Form className="form" onFinish={onFinish}>
            <Form.Item 
              name="code"
              className="label required"
              label="Código"
            >
              <Input
                className="input"
                type="code"
                required
                maxLength={6}
              />
            </Form.Item>
            <div className="container-submit">
              <Button
                className="btn-send" 
                htmlType="submit"
                loading={loading}
              >
                Enviar
              </Button>
              <Button
                className="btn-send" 
                onClick={resend}
                loading={loadingResend}
              >
                Reenviar
              </Button>
            </div>
          </Form>
        </ContainerCode>  
      </Container>
    </>
  )
}